
export const checkNumber = (check) => (value) => !value || isNaN(value) || check(+value);